import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";

import { createStore } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";

// store
const store = createStore(rootReducer, composeWithDevTools());

const rootElement = document.getElementById("root");
const snapshotPath = document.documentElement.getAttribute("data-prerender-path");
const currentPath = window.location.pathname.replace(/\/$/, "") || "/";
// Older Nginx configurations fall back to the homepage for SPA-only routes.
// Never hydrate that homepage as a cart, checkout, or designer screen.
if (snapshotPath && snapshotPath !== currentPath) {
  rootElement.textContent = "";
  document.head.querySelectorAll('script[data-seo-schema]').forEach(node => node.remove());
}

const app = (
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

if (rootElement && rootElement.hasChildNodes()) {
  ReactDOM.hydrate(app, rootElement);
} else if (rootElement) {
  ReactDOM.render(app, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
